module.exports = __webpack_public_path__ + "img/pains.d562af3d.png";